export const TEST_ID = 'assetsPage';
